import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { assets } from '../../../assets/assets';

const QuotationViewTwo = () => {
    const [formData, setFormData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();

    useEffect(() => {
        // Retrieve the URL parameters
        const query = new URLSearchParams(window.location.search);
        const formParam = query.get('form');

        if (formParam) {
            try {
                // Parse the form data
                const parsedForm = JSON.parse(decodeURIComponent(formParam));
                setFormData(parsedForm);
            } catch (error) {
                console.error('Error parsing form data:', error);
            }
        }
    }, []);


    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '0%' : '0%',
        width: isDesktop ? '98%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <img src={assets?.firmImg} alt="error" />

                        <h3 className='centered-heading'>Quotation</h3>
                        <div className="dashed-line" style={{ margin: '1% 0%' }}></div>

                        <table style={{ margin: '1% 0%', fontSize: '15px' }}>

                            <tbody>

                                <tr>

                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: ' 0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firm}</td>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.party}</td>

                                </tr>

                            </tbody>

                        </table>

                        <h3 className='centered-heading'>Price List</h3>

                        {formData?.quotData?.length > 0 &&

                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                {
                                    formData?.quotData?.map((quot, index) => (
                                        <Table key={index}>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '5%' }} align='center'>Quotation No</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '30%' }} align='center'>Size</TableCell>
                                                    {quot?.quotInfo ? quot?.quotInfo?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item?.size}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.quotNo?.quotNo}</TableCell>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{quot?.quotNo?.itemNm} -
                                                        <br /> {quot?.quotNo?.mclothNm} {quot?.quotNo?.m1 !== '0' && <br />}{quot?.quotNo?.m1 !== '0' && quot?.quotNo?.m1clothNm} {quot?.quotNo?.m2 !== '0' && <br />}
                                                        {quot?.quotNo?.m2 !== '0' && quot?.quotNo?.m2clothNm} {quot?.quotNo?.m3 !== '0' && <br />}{quot?.quotNo?.m3 !== '0' && quot?.quotNo?.m3clothNm}</TableCell>
                                                    {quot?.quotInfo ? quot?.quotInfo?.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                    )) : ''}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    ))
                                }
                            </TableContainer>
                        }

                        <div style={{ float: 'right', marginRight: '10%', textAlign: 'center' }}>
                            <h4 style={{ marginBottom: '3rem' }}>Authorized By</h4>
                            <h6>{formData.firm}</h6>
                        </div>
                    </div>
                    <div style={{ margin: '2% 5%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
}

export default QuotationViewTwo;
